export default __webpack_public_path__ + "static/great-barrier-reef-d43640768aa462a0fd2aa4aa7072cb35.jpg";